import { render, staticRenderFns } from "./NetworkData.vue?vue&type=template&id=0601c158&scoped=true&"
import script from "./NetworkData.vue?vue&type=script&lang=js&"
export * from "./NetworkData.vue?vue&type=script&lang=js&"
import style0 from "./NetworkData.vue?vue&type=style&index=0&id=0601c158&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0601c158",
  null
  
)

export default component.exports